import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import apiurl from "../../services/apiendpoint/apiendpoint";
import { MultiSelect } from "primereact/multiselect";
import { useState } from "react";
import { gethomebannerFilterOptions } from "../../services/apihomebanner/apihomebanner";

export default function Tableview ({loading, tabledata, handledelete, editfrom, onPage, cusfilter, setTempFilterValues, tempFilterValues, }) {

    const [filterOptions,setFilterOptions] = useState({});

    const edittemplateBody = (rowData) => {
        return (
            <div className="flex gap-3">
                <div title="Edit Details">
                    <i className="text-xl text-green-500 cursor-pointer fi fi-sr-pen-circle" onClick={() => editfrom(rowData)}></i>
                </div>
                <div title="Delete this record">
                    <i className="text-xl text-red-500 cursor-pointer fi fi-sr-trash" onClick={() => handledelete(rowData._id)}></i>
                </div>
            </div>
        );
    };

    const imageBodyTemplate = (rowData) => {
        if ((!rowData.DesktopImage && !rowData.MobileImage) || 
            (rowData.DesktopImage?.length === 0 && rowData.MobileImage?.length === 0)) {
            return <span>No Image</span>;
        }
        
        return (
            <div className="flex gap-2">
                {rowData.DesktopImage && (
                    <div className="flex flex-col items-center">
                        <img src={`${apiurl()}/${rowData.DesktopImage}`} alt="Desktop" className="object-cover w-12 h-12 border rounded"/>
                        <span className="mt-1 text-xs text-gray-500">Desktop</span>
                    </div>
                )}
                {rowData.MobileImage && (
                    <div className="flex flex-col items-center">
                        <img src={`${apiurl()}/${rowData.MobileImage}`} alt="Mobile" className="object-cover w-12 h-12 border rounded"/>
                        <span className="mt-1 text-xs text-gray-500">Mobile</span>
                    </div>
                )}
            </div>
        );
    };

    const categoryNameBodyTemplate = (rowData) => {
        return <span>{rowData.Banner_Name || 'N/A'}</span>;
    };

    const statusBodyTemplate = (rowData) => {
        const isActive = rowData.Status === 'Active';
        return (
            <span className={`px-2 py-1 rounded text-xs font-medium ${ isActive ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`}>
                {rowData.Status || 'Inactive'}
            </span>
        );
    };

    const columns = [
        { header: 'Action', body: edittemplateBody,width: '120px',sortable: false },
        { field: 'Images', header: 'Image', body: imageBodyTemplate, width: '200px', sortable: false },
        { field: 'Banner_Name', header: 'Banner Name', body: categoryNameBodyTemplate, width: '200px', sortable: true, filter: true},
        { field: 'redirect_link', header: 'Redirect Link',  width: '150px', filter: true},
        { field: 'Status', header: 'Status', body: statusBodyTemplate, width: '120px', sortable: true, filter: true }
    ];

    const getOption = async (key)=>{
        var filterOptions = await gethomebannerFilterOptions(key);
        setFilterOptions(filterOptions)
        console.log(filterOptions)
    }

    const handleApplyFilters = (key) => {
        cusfilter(key, tempFilterValues[key]);
        onPage({ first: 0, rows: rows });
    };

    const handleClearFilters = (key) => {
        setTempFilterValues(prev => ({ ...prev, [key]: null }));
        cusfilter(key, null);
        onPage({ first: 0, rows: rows });
    };

    const renderColumnFilter = (key) => (
        <div onClick={()=>getOption(key)}>
            <MultiSelect filter value={tempFilterValues[key]} options={filterOptions?.[key]} className="p-column-filter" virtualScrollerOptions={{ itemSize: 43 }} maxSelectedLabels={1}
                onChange={(e) => setTempFilterValues(prev => ({ ...prev, [key]: e.value }))} placeholder={`Select ${key?.charAt(0).toUpperCase() + key?.slice(1)}`} panelFooterTemplate={
                <div className="flex justify-between p-2 mt-2">
                    <button label="Clear" onClick={() => handleClearFilters(key)} className="flex items-center text-center justify-center gap-1 px-4 py-2.5 text-sm w-[45%] shadow-sm bg-black text-white cursor-pointer" >
                        Clear
                    </button>
                    <button label="Apply" onClick={() => handleApplyFilters(key)} className="flex items-center text-center justify-center gap-1 px-4 py-2.5 text-sm w-[45%] shadow-sm bg-black text-white cursor-pointer" >
                        Apply
                    </button>
                </div>
            } />
        </div>
    );

    return (
        <>
        <DataTable value={tabledata || []} loading={loading} scrollable scrollHeight="680px" className="!text-sm border border-gray-200 rounded"
            emptyMessage="No categories found" stripedRows >
            {columns.map((col, i) => (
                <Column key={i} header={col.header} field={col.field} style={{ minWidth: col.width }} body={col.body} filter={col.filter} filterElement={renderColumnFilter(col.field)}
                        showFilterMenuOptions={false} showFilterMatchModes={false} showApplyButton={false} showClearButton={false} sortable headerClassName="text-gray-700 bg-gray-50"/>
            ))}
        </DataTable>
        </>
    )
}